<template>
  <div
    class="search-filter-opener d-block d-md-none"
  >
    <div class="row row-tight">
      <div class="col-6">
        <button
          class="btn btn-secondary btn-block"
          type="button"
          @click="showModalFilter"
        >
          <i class="icon"><icon-sliders-h /></i>
          {{ $t('filter:select.filter_interval',{postProcess: 'interval',count:activeFilter}) }}
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-secondary btn-block"
          type="button"
          @click="toggleMap"
        >
          <i class="icon"><component :is="mapButtonLabel.icon" /></i>
          {{ mapButtonLabel.text }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';

/* ICONS */
import IconSlidersH from 'ICON:IconSlidersH';
import IconMapMarkerAlt from 'ICON:IconMapMarkerAlt';
import IconHomeAlternative from 'ICON:IconHomeAlternative';

export default {
  name: 'SearchFilterOpener',
  i18nOptions: { namespaces: 'filter' },
  components: {
    IconSlidersH,
    IconMapMarkerAlt,
    IconHomeAlternative,
  },
  props: {
    mapLabel: {
      type: String,
      default: 'map',
    },
  },
  computed: {
    activeFilter() {
      return this.getActiveFilterCount();
    },
    mapButtonLabel() {
      let label = {
        icon: IconMapMarkerAlt,
        text: this.$t('filter:btns.map'),
      };

      if (this.mapLabel !== 'map') {
        label = {
          icon: IconHomeAlternative,
          text: this.$t('filter:btns.list'),
        };
      }
      return label;
    },
  },
  methods: {
    ...mapMutations({ setModalStatus: 'SET_MODAL_STATUS', setMapStatus: 'SET_MAP_STATUS' }),
    ...mapGetters({ getActiveFilterCount: 'getActiveFilterCount', getMapStatus: 'getMapStatus' }),
    toggleMap() {
      const mapStatus = this.getMapStatus();
      if (mapStatus) {
        if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen();
      }
      this.$emit('open-map', true);
      this.setMapStatus({ fullscreen: !mapStatus });
    },
    showModalFilter() {
      if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen();
      this.setMapStatus({ fullscreen: false });
      // set state showModalFilter = true
      this.setModalStatus({ status: true });
    },
  },

};
</script>
<style lang="scss" scoped>
  .search-filter-opener {
    padding: $margin_content_xs;
    border-bottom: 1px solid $color_grey_100;
    margin: 0;
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 50;
  }
</style>
